/* This file (hb.js) has some utility functions:

  - Making a popup when you click on a tube/media image
  - Provides a function to check whether we're looking at the dev site or not
  - Adds extreme temperature alert in the transport instructions after the key-value div.
*/

function larger_tube(tube) {
    URL = "/path_handbook/gifs/tubes/lg/" + tube;
    wd = 350;
    ht = 350;

    aWindow = window.open("", "_New", "resizable,width=" + wd + ",height=" + ht + ",menubar=no,left=0,top=0");
    // focus() brings the window to the front
    aWindow.document.write("<html><head><title>Media</title></head><body><img src=" + URL + " /></body></html>");
    aWindow.document.close();
    aWindow.focus();
}

function addTempAdvisory() {
    const transportInstructionsKeyVal = document.querySelector(".key-value-transport-instructions");

    if (!transportInstructionsKeyVal) {
        return;
    }
    const temperatureWarning = document.createElement("div");

    temperatureWarning.innerHTML = `<div class="alert alert--warning alert--icon my-3">
    <div class="alert__icon">
      <span class="fa-stack fa-1x">
        <span role="presentation" class="fas fa-circle fa-stack-2x"></span>
        <span
          role="presentation"
          class="fas fa-stack-1x fa-inverse fa-exclamation-triangle"
        ></span>
      </span>
    </div>
    <div>
          <p class="m-0"><strong>Extreme temperatures may compromise specimens during transport.</strong> To ensure sample viability, please refer to <a href="https://uidl.medicine.uiowa.edu/sending-case" target="_blank">Sending a Case</a> and <a href="https://uidl.medicine.uiowa.edu/sending-case/specimen-instructions" target="_blank">Specimen Instructions</a> to ensure your samples are packaged appropriately.</p>
    </div>
  </div>`;
    transportInstructionsKeyVal.after(temperatureWarning);
}

document.addEventListener("DOMContentLoaded", function () {
    /* Adjust Breadcrumbs Home Item if necessary */
    const handbookLocation = window.getHandbookLocation();
    const breadcrumbItemHome = document.getElementById("breadcrumb-item-home");
    const breadcrumbItemAppendix = document.getElementById("breadcrumb-item-appendix");
    if (breadcrumbItemHome && handbookLocation == 4) {
        breadcrumbItemHome.innerHTML = `<a href="/path_handbook/rindex.html"><i class="fa-solid fa-house"></i> UIDL Test Directory</a>`;

        if (breadcrumbItemAppendix) {
            breadcrumbItemAppendix.innerHTML = `<a href="/path_handbook/rappendix.html">Additional Information</a>`;
        }
    }

    /* Add temperature advisory notice */
    addTempAdvisory();
});
